import { Link } from "@mui/material";

const EightFree = () => {
  return (
    <div className="container--blog_post_page_wrapper">
      <section className="container--blog_post">
        <div className="container--post_content">
          <p className="text--post_paragraph">
            Being an educator in today’s ever-evolving & highly tech-dominated
            world, it is imperative that teachers & professors have access to &
            master tools for remote teaching. This year presented the perfect
            example of just how important tools for remote teaching really are.
            2020 has presented numerous changes, challenges & learning
            opportunities, especially for teachers. With the majority of
            students safely learning remotely, it has required educators to
            adapt, by altering their teaching styles to provide the same quality
            education that they do when teaching in person.
          </p>
          <p className="text--post_paragraph">
            Remote teaching, by definition, “occurs when instructors transition
            the delivery of an on-campus course to online” (
            <Link
              href="https://blog.citl.mun.ca/instructionalresources/remote-vs-online-instruction/#:~:text=In%20short%2C%20remote%20teaching%20occurs,using%20online%20learning%20design%20principles."
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Learn more about remote vs. online instruction at Memorial University"
            >
              Memorial University
            </Link>
            ). When done effectively with the right tools & resources, remote
            education offers a wide variety of benefits for both students &
            educators alike. Remote teaching not only offers a safer & more
            accessible environment for students & teachers but also students
            gain more autonomy over their studies & teachers are able to give
            better & faster feedback (
            <Link
              href="https://web.stratxsimulations.com/2020/08/03/e-learning-in-education-benefits-and-best-tools-to-support-remote-teaching-and-learning/"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
            >
              StratX Simulations
            </Link>
            ). Here are 8 tools instructors can utilize to more effectively &
            efficiently teach students remotely.
          </p>
          <h2 className="header header--page_title_h2_center">1. Zoom</h2>
          <div className="img img--blog_post_img_container">
            <img
              className="img img--blog_post_image_medium"
              src={"/zoom.png"}
              alt="Zoom"
            />
          </div>
          <p className="text--post_paragraph">
            Being one of the most versatile video conferencing platforms, Zoom
            has quickly gained popularity amongst instructors & students alike.
            Many instructors have utilized Zoom as a way to provide virtual
            education to students, facilitate group discussions & connect with.
            An enormous “96% of top universities use Zoom” (
            <Link
              href="https://digital.hbs.edu/platform-digit/submission/zoom-prepared-for-a-pandemic/"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Read about how Zoom prepared for a pandemic on Digital Initiative"
            >
              Digital Initiative
            </Link>
            ).
          </p>
          <div className="img--blog_post_img_container">
            <p className="text--post_paragraph">
              Why should an instructor use Zoom? It’s features & benefits
              include:
              <ul className="text--post_bullet-alt">
                <li>HD audio & video</li>
                <li>Screen Sharing</li>
                <li>Breakout Rooms</li>
              </ul>
            </p>
          </div>
          <p className="text--post_paragraph">
            These features have enabled educators to provide thorough online
            lectures & conduct interactive discussions with their students.
          </p>
          <h2 className="header header--page_title_h2_center">2. Loom</h2>
          <div className="img img--blog_post_img_container">
            <img
              className="img img--blog_post_image_medium"
              src={"/loom.png"}
              alt="Loom"
            />
          </div>
          <p className="text--post_paragraph">
            This tool has been highly beneficial for recording video lectures
            that educators can distribute to their students, especially for
            students who are unable to understand everything that is happening
            during lectures. Instead of answering similar questions one student
            at a time, teachers can record a video on Loom then distribute the
            answer to those students.
          </p>
          <div className="img--blog_post_img_container">
            <p className="text--post_paragraph">
              According to&nbsp;
              <Link
                href="http://www.kathleenamorris.com/2019/04/10/loom-screencast/"
                target="_blank"
                rel="noreferrer noopener nofollow sponsored"
                aria-label="Read about the benefits of Loom for educators by Kathleen Morris"
              >
                Kathleen Morris
              </Link>
              , some of the benefits of Loom include:
              <ul className="text--post_bullet-alt">
                <li>
                  It is easy to use and intuitive. Almost no learning curve!
                </li>
                <li>
                  Password-protect videos or make them available only for
                  certain email addresses. If teachers or only a handful of
                  students need help, teachers can target their message to them.
                </li>
                <li>
                  There are three options to record: just face, just screen, or
                  both.
                </li>
              </ul>
            </p>
          </div>
          <p className="text--post_paragraph">
            Loom is a versatile tool that can help enhance the personalization
            and efficiency of quality instruction.
          </p>
          <h2 className="header header--page_title_h2_center">
            3. Google Suite (GSuite)
          </h2>
          <div className="img img--blog_post_img_container">
            <img
              className="img img--blog_post_image_small"
              src={"/googledrive.png"}
              alt="Google Drive"
            />
          </div>
          <p className="text--post_paragraph">
            GSuite has amazing sub-tools like Google Sheets, Google Docs, Google
            Slides, Google Forms, & much more. Instructors are able to share
            their documents, slideshows, spreadsheets & more with as many remote
            students as possible using GSuite. This makes this an amazing tool
            for teachers to stay organized & connected with their students
            remotely.
          </p>
          <div className="img--blog_post_img_container">
            <p className="text--post_paragraph">
              According to the&nbsp;
              <Link
                href="https://www.cultofpedagogy.com/"
                target="_blank"
                rel="noreferrer noopener nofollow sponsored"
                aria-label="Discover more about the benefits of Google Drive on Cult of Pedagogy"
              >
                Cult of Pedagogy
              </Link>
              , the benefits of Google Drive are:
              <ul className="text--post_bullet-alt">
                <li>It is perfect for collaboration.</li>
                <li>It is paperless.</li>
                <li>It saves automatically.</li>
              </ul>
            </p>
          </div>
          <p className="text--post_paragraph">
            It is a great tool for any instructor looking to share their
            material & collaborate with their students.
          </p>
          <h2 className="header header--page_title_h2_center">
            4. Google Classroom
          </h2>
          <div className="img img--blog_post_img_container">
            <img
              className="img img--blog_post_image_medium"
              src={"/googleclassroom.png"}
              alt="Google Classroom"
            />
          </div>
          <p className="text--post_paragraph">
            Google Classroom makes connecting with students remotely a breeze- &
            at no cost! It is a blended learning tool for both students &
            instructors. Many teachers have loved this tool, one claims “Google
            Classroom can elevate the classroom’s productivity & take workflow
            management to the next level”&nbsp;(
            <Link
              href="https://www.helloteacherlady.com/"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Learn more about Google Classroom on Hello Teacher Lady"
            >
              Hello Teacher Lady
            </Link>
            ).
          </p>
          <div className="img--blog_post_img_container">
            <p className="text--post_paragraph">
              Teacher reviews boast about other Google Classroom benefits like:
              <ul className="text--post_bullet-alt">
                <li>Workflow management is easier & organized.</li>
                <li>
                  Increased ability to monitor real-time progress on
                  assignments.
                </li>
                <li>
                  No work is ever lost thanks to the cloud computing structure
                  of Google Classroom.
                </li>
              </ul>
            </p>
          </div>
          <h2 className="header header--page_title_h2_center">5. Pear</h2>
          <div className="img img--blog_post_img_container">
            <img
              className="img img--blog_post_image_medium"
              src={"/pear.png"}
              alt="Pear"
            />
          </div>

          <p className="text--post_paragraph">
            Known as the fastest way to transform presentations into classroom
            conversations, Pear Deck, is a strong way to turn boring lectures
            that professors provide into very useful tools. If you ever want to
            know the best way to keep your students wide awake in class and
            engaged with the class, here are some methods as explained by&nbsp;
            <Link
              href="https://ditchthattextbook.com/20-ways-to-use-pear-deck-to-engage-students/"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
              aria-label="Explore 20 ways to use Pear Deck to engage students on Ditch That Textbook"
            >
              Ditch That Textbook
            </Link>
            .
          </p>
          <div className="img--blog_post_img_container">
            <p className="text--post_paragraph">
              These procedures include:
              <ul className="text--post_bullet-alt">
                <li>
                  Gather students on a video call with Skype, Zoom, Google Meet,
                  or Microsoft Teams.
                </li>
                <li>
                  Educators can share their screen with an interactive Pear Deck
                  presentation.
                </li>
                <li>
                  Students follow along with the presentation & interact with
                  the slides.
                </li>
              </ul>
            </p>
          </div>
          <h2 className="header header--page_title_h2_center">6. Kahoot</h2>
          <div className="img img--blog_post_img_container">
            <img
              className="img img--blog_post_image_medium"
              src={"/kahoot.png"}
              alt="Kahoot"
            />
          </div>

          <p className="text--post_paragraph">
            A lot of universities have been using this class competition
            quizzing tool to test the knowledge of their students. It is a fun,
            easy-to-use platform that makes learning a bit more exciting &
            interactive, especially when remote teaching. With Kahoot, students
            become more engaged & excited about mastering new material.
          </p>
          <div className="img--blog_post_img_container">
            <p className="text--post_paragraph">
              <Link
                href="https://edtechreview.in/news/1490-how-kahoot-can-help-teachers-to-engage-students"
                target="_blank"
                rel="noreferrer noopener nofollow sponsored"
                aria-label="Read about how Kahoot can help teachers to engage students on EdTech Review"
              >
                EdTech Review
              </Link>
              &nbsp;explains how Kahoot works:
              <ul className="text--post_bullet-alt">
                <li>Ask thought-provoking questions.</li>
                <li>Help students take control of their learning.</li>
                <li>It is Easy-To-Use.</li>
              </ul>
            </p>
          </div>
          <p className="text--post_paragraph">
            If an educator has a lecture to present & would like to engage
            students, they should consider utilizing Kahoot.
          </p>
          <h2 className="header header--page_title_h2_center">7. TeammateMe</h2>
          <div className="img img--blog_post_img_container">
            <img
              className="img img--blog_post_image_small"
              src={"/teammateme_logo.png"}
              alt="TeammateMe"
            />
          </div>
          <p className="text--post_paragraph">
            The optimal platform for educators & students alike! Instructors can
            utilize specific course codes so their classes can form teams on the
            platform & accomplish group projects. Students can search through
            descriptive user profiles & reputation scores to pick the best
            teammates to help them successfully complete any assignment.
            TeammateMe&apos;s easy-to-use features also enable students to
            efficiently find the right group to join to exceed shared goals &
            objectives.
          </p>
          <div className="img--blog_post_img_container">
            <p className="text--post_paragraph">
              TeammateMe offers a wide variety of benefits like:
              <ul className="text--post_bullet-alt">
                <li>
                  Instructors can enable students to form teams to collaborate.
                </li>
                <li>
                  Instructors can find teaching assistants, quest speakers &
                  more.
                </li>
                <li>
                  Instructors can find co-authors for their research projects.
                </li>
                <li>
                  Students can form their own groups to tackle group projects.
                </li>
                <li>
                  Students can join the best groups that match their objectives
                  & interests.
                </li>
                <li>Students can find study-mates to study in groups.</li>
                <li>
                  Students can learn collaboration, teamwork & other
                  professional skills.
                </li>
                <li>Students can form teams for extracurricular activities.</li>
              </ul>
            </p>
          </div>
          <p className="text--post_paragraph">
            TeammateMe is perfect for creating class teams, tackling group
            assignments & holding team members accountable with the member
            rating system.
          </p>
          <h2 className="header header--page_title_h2_center">
            8. Backchannel Chat
          </h2>
          <div className="img img--blog_post_img_container">
            <img
              className="img img--blog_post_image_small"
              src={"/backchannelchat.png"}
              alt="Backchannel Chat"
              aria-label="Learn about the features of Backchannel Chat"
            />
          </div>
          <p className="text--post_paragraph">
            This tool bridges the gap between teachers & students by
            facilitating one-on-one conversations between instructors &
            students. As soon as a student has a question, they can reach out to
            their teacher with an instant message instead of an email. This
            solidifies & strengthens the relationship between instructor &
            student, leading to possible future collaborations. Educators can
            also share resources directly through the chat space.
          </p>
          <p className="text--post_paragraph">
            The&nbsp;
            <Link
              href="http://backchannelchat.com/Benefits"
              target="_blank"
              rel="noreferrer noopener nofollow sponsored"
            >
              features
            </Link>
            &nbsp;for this tool include:
            <ul className="text--post_bullet-alt">
              <li>
                Real-Time. Students can ask educators questions at any time &
                any place throughout the world.
              </li>
              <li>
                Students can pick avatars as codes for the instructor to know
                who he or she is.
              </li>
              <li>
                Profanity Filter. The language used in this chat is
                age-appropriate.
              </li>
            </ul>
          </p>
          <p className="text--post_paragraph">
            Backchannel Chat is a tool that is highly likely to keep the
            relationship between instructors & students going strong throughout
            the school year.
          </p>
        </div>
        <hr className="hr--form_break" />
      </section>
    </div>
  );
};

export default EightFree;
